import { FORMAT_DATE_ISO_SHORT } from '@/constants';
import dayjs from 'dayjs';

export const formatDateToISOShort = (value: string | number | Date | null): string => {
    if (!value) return '';
    return dayjs(new Date(value)).format(FORMAT_DATE_ISO_SHORT);
};
